import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForTenUsersText,
    Headings,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../../components";

export const LoggedInJiraFreeExistingSitesUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    {team26VisualUpdates ? (
                        <Headings
                            main={<WelcomeBackText />}
                            sub={<FreeForTenUsersText />}
                        />
                    ) : (
                        <>
                            <h1 css={headerCss}>
                                <WelcomeBackHeading />
                            </h1>
                            <p css={subHeaderCss}>
                                <FormattedMessage
                                    id="signupForm.accountCreation.subHeaderText"
                                    defaultMessage="It’s free for up to 10 users - no credit card needed."
                                />
                            </p>
                        </>
                    )}
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    margin: "0 auto",
    textAlign: "center"
});
